// extracted by LIB_CSS_EXTRACT_LOADER
import "./form-skeleton_module.css"
export default {"form":"form-gfhZPq","field":"field-t5tCr8","label":"label-iFnf4q","input":"input-PmNyaP","submit":"submit-CrufDt"};